// extracted by mini-css-extract-plugin
export var active = "_4t-7";
export var container = "_4t-0";
export var evenWidth = "_4t-4";
export var large = "_4t-5";
export var outlet = "_4t-8";
export var slide = "_4t-2";
export var small = "_4t-6";
export var tab = "_4t-3";
export var tabs = "_4t-1";